(function () {
  if (window.__lfcInit) return; window.__lfcInit = true;
  var root = document.querySelector('[data-lfc]');
  if (!root) return;
  // En la portada conviven DOS cajones (el del header interno oculto y el
  // propio). Nos quedamos con uno y lo movemos a <body> para que ningún
  // contenedor con display:none lo esconda.
  function dedupe() {
    document.querySelectorAll('[data-lfc]').forEach(function (el) { if (el !== root) el.remove(); });
    if (root.parentNode !== document.body) document.body.appendChild(root);
  }
  dedupe();
  // el segundo cajón (portada) se renderiza DESPUÉS de este script: limpiar de nuevo al cargar
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dedupe);
  /* Accesorios (plantillas, cremas…): no cuentan como par para el calzador de regalo */
  var ACCESORIOS = window.HR_LFC_CFG.acc;
  /* Envío: barra con rayas en movimiento (assets/hr-cart-zv.js). El umbral es el de la tarifa de
     Shopify (HR_LFC_CFG.envio). Todo el calzado cuesta más que eso, así que con un zapato el envío
     siempre es gratis; solo los accesorios sueltos pueden quedar por debajo y pagar envío. */
  var UMBRAL_ENVIO = window.HR_LFC_CFG.envio || 0;
  function avisoEnvio(c) {
    var l = root.querySelector('[data-lfc-total-l]');
    function etiqueta(g) { if (l) l.textContent = g ? 'Total' : 'Subtotal'; }
    etiqueta(window.HRZ ? window.HRZ.envio(root.querySelector('[data-lfc-envio]'), c.total_price, UMBRAL_ENVIO, c.items || [], etiqueta) : true);
  }
  /* "Verifique bien las tallas…" solo cuando algún producto tiene talla. */
  function notaTalla(c) {
    var n = root.querySelector('[data-lfc-nota-talla]');
    if (!n) return;
    n.hidden = !(c.items || []).some(function (it) {
      return (it.options_with_values || []).some(function (o) { return /talla/i.test(o.name || ''); });
    });
  }
  var body = root.querySelector('[data-lfc-items]');
  var foot = root.querySelector('[data-lfc-foot]');
  var cuenta = root.querySelector('[data-lfc-count]');
  var sub = root.querySelector('[data-lfc-subtotal]');

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }
  function abrir() { root.hidden = false; root.setAttribute('aria-hidden', 'false');
    // setTimeout y no requestAnimationFrame: rAF no corre si la pestaña está
    // en segundo plano y el panel se quedaría fuera de pantalla.
    setTimeout(function () { root.classList.add('is-on'); }, 20); cargar(); }
  function cerrar() { root.classList.remove('is-on'); root.setAttribute('aria-hidden', 'true');
    setTimeout(function () { root.hidden = true; }, 340); }

  // Botón del carrito en el encabezado: vacío muestra la caja Rómulo; con algo dentro muestra
  // la foto del par agregado, y si hay más de uno se asoma un disco detrás, como una pila.
  function iconoCarrito(c) {
    var primero = c.items && c.items.length ? c.items[0] : null;
    document.querySelectorAll('[data-cart-ic]').forEach(function (ic) {
      var caja = ic.querySelector('.lf-cartic__box');
      var foto = ic.querySelector('.lf-cartic__img');
      if (!primero) {
        if (foto) foto.remove();
        if (caja) caja.removeAttribute('style');
        ic.classList.remove('is-full');
        return;
      }
      var url = primero.image || '';
      if (url) url += (url.indexOf('?') === -1 ? '?' : '&') + 'width=120';
      if (!foto) {
        foto = document.createElement('img');
        foto.className = 'lf-cartic__img';
        foto.alt = '';
        foto.setAttribute('aria-hidden', 'true');
        ic.appendChild(foto);
      }
      if (foto.getAttribute('src') !== url) foto.setAttribute('src', url);
      if (caja) caja.style.display = 'none';
      // Nada de fotos apiladas: a 26 px solo se asoma un borde blanco y parece un fallo.
      // El número dorado ya dice cuántos pares hay.
      ic.classList.add('is-full');
    });
  }

  // La guía «7 días» está escrita para mujer: si el carrito solo trae calzado de hombre, la línea
  // de regalos deja solo el calzador. Los productos sin género en el título (accesorios) no cuentan.
  function guiaRegalo(c) {
    var g = root.querySelector('[data-lfc-gift-guia]');
    if (!g) return;
    var ts = (c.items || []).map(function (it) { return String(it.product_title || it.title || '').toLowerCase(); });
    var hayH = ts.some(function (t) { return /hombre|caballero/.test(t); });
    var hayM = ts.some(function (t) { return /mujer|dama|unisex/.test(t); });
    g.hidden = hayH && !hayM;
    /* El calzador solo se ofrece si hay al menos un Rómulo en el carrito (17-oct-2026) */
    var hayRom = (c.items || []).some(function (it) { return /romulo/.test(String(it.product_title || it.title || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()); });
    var cal = root.querySelector('[data-lfc-gift-cal]'), sep = root.querySelector('[data-lfc-gift-sep]'), p = root.querySelector('[data-lfc-gift]');
    if (cal) cal.hidden = !hayRom;
    if (sep) sep.hidden = g.hidden;
    if (p) p.hidden = g.hidden && !hayRom;
  }

  // Calzador de regalo desde 2 pares. No se agrega como línea del pedido (habría que cobrarlo
  // o crear un descuento automático); se muestra en el cajón y se marca el pedido con un
  // atributo para que en despacho sepan que hay que empacarlo.
  var regaloPuesto = null;
  var regaloEstado = null;
  // Cuentan para el calzador solo los pares del local: Rómulo y FLEXRUN, y con al menos un Rómulo
  // (2 FLEXRUN solos no llevan calzador). Dropi nunca cuenta: lo despacha el proveedor. 16-oct-2026.
  function tituloPlano(it) { return String(it.product_title || it.title || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); }
  function esRomulo(it) { return tituloPlano(it).indexOf('romulo') !== -1; }
  function esFlexrun(it) { return tituloPlano(it).indexOf('flexrun') !== -1; }
  function regaloCalzador(c) {
    /* El aviso con la barra puede estar apagado (ver hr-lf-cart.liquid). El calzador se sigue
       agregando y quitando igual: lo único que desaparece es el cartel. */
    var caja = root.querySelector('[data-lfc-reg]');
    var cfg = window.HR_LFC_CFG && window.HR_LFC_CFG.regalo;
    if (!cfg) return;

    var pares = 0, romulo = 0;
    (c.items || []).forEach(function (it) {
      if (it.handle === cfg.handle) return;              // el calzador no cuenta como par
      if (ACCESORIOS.indexOf(it.handle) !== -1) return;  // plantillas y cremas tampoco
      if (esRomulo(it)) { romulo += it.quantity; pares += it.quantity; return; }
      if (esFlexrun(it)) pares += it.quantity;           // FLEXRUN suma, pero solo junto a un Rómulo
    });

    var listo = pares >= cfg.min && romulo >= 1;

    // El calzador entra y sale del carrito solo. El descuento automático de Shopify lo deja en $0.
    // Este ajuste va ANTES de pintar el aviso: si el cliente borra todo el calzado, el calzador
    // tiene que salir igual, y antes se quedaba dentro porque la función se cortaba aquí.
    // Se actúa solo cuando el estado cambia; si el cliente lo borra a mano, se respeta.
    var lineaCal = null;
    (c.items || []).forEach(function (it) { if (it.handle === cfg.handle) lineaCal = it.key; });
    if (regaloEstado === null || listo !== regaloEstado) {
      regaloEstado = listo;
      if (listo && !lineaCal && cfg.variante) {
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: cfg.variante, quantity: 1 }) }).then(cargar).catch(function () {});
      } else if (!listo && lineaCal) {
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineaCal, quantity: 0 }) }).then(function () {
            /* En la página del carrito el HTML ya se pintó con el regalo dentro: se recarga para
               que la lista no muestre una fila que ya no existe. Solo ocurre una vez. */
            if (/^\/cart/.test(location.pathname)) { location.reload(); return; }
            cargar();
          }).catch(function () {});
      }
    }

    if (!caja) { marcaPedido(c, listo); return; }

    caja.hidden = romulo < 1;   /* sin Rómulo en el carrito no se muestra la oferta del calzador (17-oct-2026) */

    var faltan = romulo >= 1 ? cfg.min - pares : Math.max(1, cfg.min - pares);
    var t = caja.querySelector('[data-lfc-reg-t]');
    var sub = caja.querySelector('[data-lfc-reg-s]');
    var chip = caja.querySelector('[data-lfc-reg-chip]');
    var bar = caja.querySelector('[data-lfc-reg-bar]');
    var run = caja.querySelector('[data-lfc-reg-run]');
    var cta = caja.querySelector('[data-lfc-reg-cta]');

    if (listo) {
      t.innerHTML = '<b>Calzador de regalo</b> desbloqueado';
      sub.textContent = 'Se lo empacamos con su pedido.';
    } else {
      t.innerHTML = (faltan === 1 ? 'Le falta <b>un par</b>' : 'Le faltan <b>' + faltan + ' pares</b>') + ' Rómulo para su <b>calzador de regalo</b>';
      sub.textContent = 'Sirve para calzarse sin agacharse.';
    }
    chip.hidden = !listo;
    if (cta) cta.hidden = listo;
    caja.classList.toggle('is-on', listo);

    var pct = listo ? 100 : Math.min(Math.round((cfg.min - faltan) * 100 / cfg.min), 99);
    bar.style.width = pct + '%';
    /* El calzador se apoya sobre la barra: se descuenta su propio ancho para que en 0 % y en
       100 % quede dentro y no se salga por los extremos. */
    if (run) run.style.left = 'calc((100% - 32px) * ' + (pct / 100) + ')';


    marcaPedido(c, listo);
  }

  // Marca en el pedido para el equipo de despacho.
  function marcaPedido(c, listo) {
    var deseado = listo ? 'Calzador (regalo por 2 pares del local, con al menos un Rómulo)' : '';
    var actual = (c.attributes && c.attributes['Regalo']) || '';
    if (actual !== deseado && regaloPuesto !== deseado) {
      regaloPuesto = deseado;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Regalo': deseado } })
      }).catch(function () { regaloPuesto = null; });
    }
  }

  function pinta(c) {
    cuenta.textContent = c.item_count ? '(' + c.item_count + ')' : '';
    // burbujas del ícono del carrito en toda la página
    document.querySelectorAll('[data-cart-count], .lf-count, .iconbtn__count').forEach(function (b) {
      b.textContent = c.item_count; b.hidden = c.item_count === 0;
      b.style.display = c.item_count === 0 ? 'none' : '';
    });
    iconoCarrito(c);
    regaloCalzador(c);
    guiaRegalo(c);
    var extra = root.querySelector('[data-lfc-extra]');
    if (window.HRZ) window.HRZ.pildora(root.querySelector('[data-lfc-pill]'), c.items || []);
    notaTalla(c);
    if (!c.items || !c.items.length) {
      avisoEnvio(c);
      foot.hidden = true; if (extra) extra.hidden = true;
      body.innerHTML = '<div class="lfc__vacio">' +
        '<div class="lfc__vacio-ic"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h12l-1.2 13.1A2 2 0 0 1 14.8 22H9.2a2 2 0 0 1-2-1.9L6 7Z"/><path d="M9 7V5a3 3 0 0 1 6 0v2"/></svg></div>' +
        '<div class="lfc__vacio-t">Su carrito está vacío</div>' +
        '<p class="lfc__vacio-p">Aún no ha agregado ningún par. ¿Le ayudamos a escoger su talla?</p>' +
        '<a class="lfc__btn lfc__btn--pay" href="/collections/all">Ver el calzado</a></div>';
      return;
    }
    foot.hidden = false; if (extra) extra.hidden = false;
    avisoEnvio(c);
    recomienda(c);
    sub.textContent = money(c.total_price);
    ahorroTotal(c);
    body.innerHTML = c.items.map(function (it, i) {
      /* "Default Title" es la opción que Shopify inventa para productos de una sola variante
         (el calzador): no se muestra. */
      var opts = (it.options_with_values || [])
        .filter(function (o) { return String(o.value || '').toLowerCase() !== 'default title'; })
        .map(function (o) { return o.name + ': ' + o.value; }).join(' · ');
      var img = it.image ? (/\.svg(\?|$)/i.test(it.image) ? it.image.split('?')[0] + '?width=160&format=png' : it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) : '';
      /* Precio tachado: el mayor entre el precio "antes" de la ficha (propiedad _antes,
         que Shopify no manda en /cart.js) y el precio antes de descuentos reales. */
      var antes = Math.max(it.original_line_price, antesLinea(it));
      var oferta = antes > it.final_line_price
        ? '<span class="lfc-item__was">' + money(antes) + '</span>' : '';
      var cfgR = window.HR_LFC_CFG && window.HR_LFC_CFG.regalo;
      var esRegalo = !!(cfgR && it.handle === cfgR.handle && it.final_line_price === 0);
      /* El regalo no lleva cantidad ni "Eliminar": subirlo a 2 le cobraría la segunda unidad. */
      var controles = esRegalo
        ? '<span class="lfc-item__gift">Regalo</span>'
        : '<span class="lfc-qty">' +
            '<button type="button" data-lfc-menos aria-label="Quitar uno">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-lfc-mas aria-label="Agregar uno">+</button>' +
          '</span>';
      return '<div class="lfc-item' + (esRegalo ? ' is-regalo' : '') + '" data-lfc-line="' + (i + 1) + '">' +
        '<a class="lfc-item__img" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="lfc-item__in">' +
          '<a class="lfc-item__t" href="' + it.url + '">' + it.product_title + '</a>' +
          (opts ? '<div class="lfc-item__opt">' + opts + '</div>' : '') +
          '<div class="lfc-item__bot">' + controles +
            '<span class="lfc-item__p">' + oferta + money(it.final_line_price) + '</span>' +
          '</div>' +
          (esRegalo ? '' : '<button type="button" class="lfc-item__del" data-lfc-quitar>Eliminar</button>') +
        '</div></div>';
    }).join('');
  }

  function antesLinea(it) {
    var a = it.properties && parseInt(it.properties._antes, 10);
    return a > 0 ? a * it.quantity : 0;
  }
  /* "Usted ahorra" en el pie: rebajas de la ficha + descuentos reales (calzador). */
  function ahorroTotal(c) {
    var fila = root.querySelector('[data-lfc-ahorro]');
    if (!fila) return;
    var t = (c.items || []).reduce(function (s, it) {
      return s + Math.max(0, Math.max(it.original_line_price, antesLinea(it)) - it.final_line_price);
    }, 0);
    fila.hidden = t <= 0;
    var v = fila.querySelector('[data-lfc-ahorro-v]');
    if (v) v.textContent = money(t);
  }

  /* Recomendados al estilo Zavatty (foto, precio, estrellas y colores): las tarjetas las arma
     sections/hr-cart-reco y las trae HRZ.reco. Se recargan solo si cambia el primer producto. */
  var recoPara = null;
  function recomienda(c) {
    var caja = root.querySelector('[data-lfc-reco]');
    if (!caja || !c.items.length || !window.HRZ) return;
    var pid = c.items[0].product_id;
    var enCarrito = c.items.map(function (i) { return i.product_id; });
    var clave = pid + '|' + enCarrito.join(',');
    if (recoPara === clave) return;        // ya cargadas para este carrito
    recoPara = clave;
    window.HRZ.reco(caja, pid, { excluir: enCarrito, limite: 6, puntos: true });
  }

  function cargar() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(pinta).catch(function () {});
  }
  function cambia(linea, cantidad) {
    body.style.opacity = '0.5';
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: linea, quantity: cantidad }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, cart: j }; }); })
      .then(function (res) {
        body.style.opacity = '';
        if (res.ok && res.cart && Array.isArray(res.cart.items)) {
          pinta(res.cart);
          var it = res.cart.items[linea - 1];
          if (cantidad > 0 && it && it.quantity < cantidad) aviso('No hay más unidades de esa talla.');
          return;
        }
        // Error (p. ej. sin más stock de esa talla): mantener el carrito real
        cargar();
        if (cantidad > 0) aviso('No hay más unidades de esa talla.');
      })
      .catch(function () { body.style.opacity = ''; cargar(); });
  }
  var avisoT = null;
  function aviso(txt) {
    var el = root.querySelector('[data-lfc-aviso]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-lfc-aviso', '');
      el.style.cssText = 'position:absolute;left:50%;transform:translateX(-50%);background:#1A1815;color:#fff;font-size:12.5px;padding:9px 16px;border-radius:20px;white-space:nowrap;z-index:5;opacity:0;transition:opacity 200ms;pointer-events:none;';
      root.querySelector('.lfc__panel').appendChild(el);
    }
    // Se apoya justo encima del pie: antes iba a 96 px fijos y quedaba encima del subtotal.
    // Se acota para que, si la medida sale rara, nunca termine a media altura del cajón.
    var pie = root.querySelector('.lfc__foot');
    var panel = root.querySelector('.lfc__panel');
    var altoPie = pie && !pie.hidden ? pie.getBoundingClientRect().height : 0;
    var tope = (panel ? panel.getBoundingClientRect().height : 0) * 0.45;
    var abajo = altoPie + 16;
    if (tope > 120 && abajo > tope) abajo = tope;
    if (abajo < 96) abajo = 96;
    el.style.bottom = abajo + 'px';
    el.textContent = txt;
    el.style.opacity = '1';
    clearTimeout(avisoT);
    avisoT = setTimeout(function () { el.style.opacity = '0'; }, 2600);
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-lfc-close]')) { cerrar(); return; }
    var fila = e.target.closest('[data-lfc-line]');
    if (!fila) return;
    var linea = parseInt(fila.getAttribute('data-lfc-line'), 10);
    var actual = parseInt(fila.querySelector('.lfc-qty span').textContent, 10) || 1;
    if (e.target.closest('[data-lfc-mas]')) cambia(linea, actual + 1);
    else if (e.target.closest('[data-lfc-menos]')) cambia(linea, Math.max(0, actual - 1));
    else if (e.target.closest('[data-lfc-quitar]')) cambia(linea, 0);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) cerrar(); });

  // El ícono del carrito abre el cajón (en vez de ir a /cart)
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open], .lf-head__tool[href$="/cart"], a[href="/cart"].lf-head__tool');
    if (!t) return;
    if (t.closest('[data-lfc]')) return;
    // stopPropagation: evita que el handler viejo del tema abra su propio cajón
    e.preventDefault(); e.stopPropagation(); abrir();
  }, true);

  // Al agregar al carrito (desde la ficha), abrir el cajón con el producto dentro
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/add(\.js)?/.test(url)) {
      p.then(function (r) {
        if (r && r.ok) { setTimeout(abrir, 260); return; }
        if (r && r.status === 422) {
          setTimeout(function () {
            abrir();
            setTimeout(function () { aviso('Ya tiene todas las unidades disponibles en su carrito.'); }, 600);
          }, 260);
        }
      }).catch(function () {});
    }
    return p;
  };

  cargar();
})();
